export default __webpack_public_path__ + "static/media/road-G-photo.aad35809.svg";